import Spinner from "react-bootstrap/Spinner";

function LoadingDiv() {
	return <div className="p-4" style={{textAlign: 'center'}}> <Spinner className="text-orange" animation="border" /></div>

}

export default LoadingDiv;
